import { render, staticRenderFns } from "./DateTimeInputWrapper.vue?vue&type=template&id=87311368&scoped=true"
import script from "./DateTimeInputWrapper.vue?vue&type=script&lang=ts"
export * from "./DateTimeInputWrapper.vue?vue&type=script&lang=ts"
import style0 from "./DateTimeInputWrapper.vue?vue&type=style&index=0&id=87311368&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87311368",
  null
  
)

export default component.exports